module.exports = __webpack_public_path__ + "static/media/icono-salsa-blanca-compradores-ar.0724ae45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-salsa-blanca-compradores-ar.png
// module id = 319
// module chunks = 0